import { Skeleton } from "@tellescope/ui";
import { Card } from "@tellescope/design-system";

interface AppointmentListSkeletonProps {
  count?: number;
}

export const AppointmentListSkeleton = ({ count = 3 }: AppointmentListSkeletonProps) => {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <Card variant="floating" padding="root" key={i}>
          <Card.Body className="px-4 py-3">
            <div className="flex gap-4">
              <Skeleton className="w-14 h-14 rounded-lg" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-3 w-1/2" />
                <Skeleton className="h-3 w-1/3" />
              </div>
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};
